import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { Heading as Heading$1 } from "braid-design-system";
import { cloneElement } from "react";
import { gradientText } from "./Heading.css.mjs";
const Heading = ({
  children,
  icon: iconProp,
  ...restProps
}) => {
  assert(
    !iconProp || iconProp.props.tone === void 0,
    "Icons cannot set the `tone` prop when passed to the `Heading` component — it is always `brandAccent`."
  );
  const icon = iconProp ? cloneElement(iconProp, { tone: "brandAccent" }) : void 0;
  return /* @__PURE__ */ jsx(Heading$1, { ...restProps, icon, children: /* @__PURE__ */ jsx("span", { className: gradientText, children }) });
};
export {
  Heading
};
